const escapeChars: string = ")]}',\n";
const escapeCharsLength: number = escapeChars.length;

/**
 *
 * Use this function to escape leading ")]}',\n" characters that are
 * prepended to response text when using pb5jsonify() on the backend
 *
 * @param responseText - response from fetch() call
 * @returns escaped responseText
 */
export const jsonifyEscape = (responseText: string): string => {
  if (responseText.startsWith(escapeChars)) {
    responseText = responseText.slice(escapeCharsLength);
  }

  return responseText;
};
